export class User {
  constructor(readonly userId: string) {}
}
